import { Box, Button, Flex, Heading, SimpleGrid, Table, Tbody, Td, Tr } from '@chakra-ui/react'
import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from "../CSS/common.module.css";

export const Dashboard = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const isLoading = useSelector((state) => state.user.isLoading);
  const orgId = useSelector((state) => state.user.orgId);

  if (isLoading) {
    return <p style={{ textAlign: "center" }}>...Loading</p>
  }
  return (
    <Box>
      <Flex shadow="2xl" bgColor="lavender" w="80%" p={5} m="auto" align="center" border="2px solid #917FB3" mt={10} borderRadius="30px" h="400px">
        <Box w="45%" pl={5} >
          <Heading size="lg" ml={5} textDecor="underline" fontFamily={"Open Sans"} fontWeight={"semibold"} mb={5}>Profile Details</Heading>

          <Table w="350px" color="black" >
            <Tbody>
              <Tr>
                <Td border="none" py={2}>Employee Id:</Td>
                <Td border="none" py={2}>{user?.userInfo.userDetailsDto?.empId}</Td>
              </Tr>
              <Tr>
                <Td border="none" py={2}>Employee Name:</Td>
                <Td border="none" py={2}>{user?.userInfo.userDetailsDto?.fullname}</Td>
              </Tr>
              <Tr>
                <Td border="none" py={2}>Email Id:</Td>
                <Td border="none" py={2}>{user?.userInfo.userDetailsDto?.email}</Td>
              </Tr>
              {
                user.userInfo.userDetailsDto.role === "OWNER" ? "" :
                  <Tr>
                    <Td border="none" py={2}>Organization</Td>
                    <Td border="none" py={2}>{user?.userInfo.userDetailsDto?.organization}</Td>
                  </Tr>
              }

            </Tbody>
          </Table>
        </Box>
        <SimpleGrid columns={2} flexWrap={'wrap'} w="80%" ml="300px" gap={10} >
          {user.userInfo.userDetailsDto && user.userInfo.userDetailsDto.role === "USER" &&
            <Button _hover={{ bgColor: "none" }} color="white" bgColor="#AEC6F4" className={styles.btn} onClick={() => navigate(`/myforms?orgId=${orgId}`)}>View Form</Button>}

          {user.userInfo.userDetailsDto && user.userInfo.userDetailsDto.role === "ADMIN" &&
            <>
              <Button bgColor="#AEC6F4" _hover={{ bgColor: "none" }} color="white" className={styles.btn} onClick={() => navigate(`/myforms?orgId=${orgId}`)}>View Form</Button>
              <Button bgColor="#AEC6F4" _hover={{ bgColor: "none" }} color="white" className={styles.btn} onClick={() => navigate(`/createteam?orgId=${orgId}`)}>Create Team</Button>

              {/* <Button bgColor="#AEC6F4" _hover={{ bgColor: "none" }} color="white" className={styles.btn} onClick={() => navigate(`/addmember?orgId=${orgId}`)}>Add Member</Button> */}

              <Button bgColor="#AEC6F4" _hover={{ bgColor: "none" }} color="white" className={styles.btn} onClick={() => navigate(`/createform?orgId=${orgId}`)}>Create Form</Button>
            </>
          }

          {user.userInfo.actions && user.userInfo.actions.includes("CREATE_ADMIN") &&
            <Button bgColor="#AEC6F4" _hover={{ bgColor: "none" }} color="white" className={styles.btn} onClick={() => navigate(`/createadmin?orgId=${orgId}`)}>Create Admin</Button>}

          {user.userInfo.actions && user.userInfo.actions.includes("CREATE_SUPER_ADMIN") &&
            <Button bgColor="#AEC6F4" _hover={{ bgColor: "none" }} color="white" className={styles.btn} onClick={() => navigate('/superadmin')}>Create SuperAdmin</Button>}
          {user.userInfo.actions && user.userInfo.actions.includes("CREATE_ORGANISATION") &&
            <Button bgColor="#AEC6F4" _hover={{ bgColor: "none" }} color="white" className={styles.btn} onClick={() => navigate('/createorg')}>Create Organization</Button>}
        </SimpleGrid>
      </Flex>
    </Box>
  )
}
